import React from "react";


export default function Switch({ enabled, onclick }) {
  return <button className='ds-switch' data-enabled={enabled} type="button" onClick={onclick}></button>
}


/*

Usage:

<Switch enabled={} onclick={} />

- enabled (Optional): Bool
- onclick (Optional): Function

*/
